/* lr-konfig.js – Lorelia: zentrale Produktkonfiguration + Prüfschicht vor dem Warenkorb (schema_version 1, 30.09.2026)

   Einbindung (layout/theme.liquid, VOR lr-vorbelegen.js):
     <script src="{{ 'lr-konfig.js' | asset_url }}" data-konfig-url="{{ 'lr-konfig.json' | asset_url }}" defer></script>

   API (stabil, für alten und neuen Gestalter):
     LoreliaKonfig.version                  -> schema_version (1)
     LoreliaKonfig.aktiv                    -> Prüfschicht an? (localStorage lr-neu=1 oder data-scharf="1")
     LoreliaKonfig.bereit                   -> Promise, erfüllt mit den Daten, sobald lr-konfig.json geladen ist
     LoreliaKonfig.produkt(id, varianteId)  -> Produktkonfiguration (Felder, Varianten, Schrift, Farbe, Sternkarte …) oder null
     LoreliaKonfig.pruefe(id, eingabe)      -> {ok, fehler:[…], hinweise:[…], alle:[…]}   (reine Funktion, kein DOM)
     LoreliaKonfig.warenkorb(id, eingabe)   -> {properties:{…}}  inkl. _lr_konfig_version
     LoreliaKonfig.zeileLesen(lineItem)     -> {version, status:'ok'|'manuell pruefen', …}  (Umstieg alter Warenkörbe)
   Seite (nur wenn aktiv): fängt die Warenkorb-Knöpfe von Gestalter 8 (teeinblue) und der Schmuckseite (lr-sch.js)
   in der Capture-Phase ab, prüft, zeigt Meldungen AM Feld (eigenes Element, nie im teeinblue-DOM).
   Schreibt nie in teeinblue-Felder, kürzt oder ändert keine Eingaben. Fehler im eigenen Code => altes Verhalten. */
(function () {
  'use strict';
  var W = window, D = document;
  if (W.LoreliaKonfig && W.LoreliaKonfig.__lrk) return;

  var SKRIPT = D.currentScript || D.querySelector('script[data-konfig-url]') || D.querySelector('script[src*="lr-konfig"]');
  var URL_JSON = SKRIPT && SKRIPT.getAttribute('data-konfig-url');
  try {
    var qs = location.search;
    if (/[?&]lr_neu=1(&|$)/.test(qs)) localStorage.setItem('lr-neu', '1');
    if (/[?&]lr_neu=0(&|$)/.test(qs)) localStorage.removeItem('lr-neu');
  } catch (e) {}
  var AKTIV = !!(SKRIPT && SKRIPT.getAttribute('data-scharf') === '1');
  try { AKTIV = AKTIV || localStorage.getItem('lr-neu') === '1'; } catch (e) {}
  var RUHIG = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================================================================ Daten */
  var DATEN = null, LADEN = null, RX = {};
  function laden() {
    if (LADEN) return LADEN;
    if (!URL_JSON) { LADEN = Promise.reject(new Error('lr-konfig: data-konfig-url fehlt')); LADEN.catch(function () {}); return LADEN; }
    LADEN = fetch(URL_JSON, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('lr-konfig.json HTTP ' + r.status);
      return r.json();
    }).then(function (d) {
      if (!d || d.schema_version !== 1) throw new Error('lr-konfig.json: unbekannte schema_version ' + (d && d.schema_version));
      DATEN = d; K.konfig_version = d.konfig_version; K.geladen = true;
      return d;
    });
    LADEN.catch(function (e) { K.ladefehler = String(e && e.message || e); });
    return LADEN;
  }

  function regex(q) {
    if (!q) return null;
    if (q.charAt(0) === '@') q = (DATEN && DATEN.zeichen && DATEN.zeichen[q.slice(1)]) || null;
    if (!q) return null;
    if (!RX[q]) { try { RX[q] = new RegExp(q, 'u'); } catch (e) { RX[q] = null; } }
    return RX[q];
  }

  /* Kompakte Einträge wieder vollständig machen (Verweise auflösen, Standardwerte setzen) */
  function vollstaendig(pid, roh) {
    if (!roh) return null;
    if (roh.__voll) return roh;
    var sys = roh.system, alleArt = {}, alleTpl = {};
    (roh.vorlagen || []).forEach(function (v) { alleArt[v.artwork_id] = 1; alleTpl[v.template_id] = 1; });
    (roh.felder || []).forEach(function (f) {
      var r = (DATEN.texte && DATEN.texte.rollen && DATEN.texte.rollen[f.rolle]) || {};
      if (f.hilfe == null) f.hilfe = r.hilfe || '';
      if (!f.beispiele) f.beispiele = f.beispiel ? [f.beispiel] : [];
      f.produktion = f.produktion || {};
      if (!f.produktion.system) f.produktion.system = sys === 'teeinblue' ? 'teeinblue' : 'warenkorb-property';
      if (sys === 'teeinblue') {
        if (!f.produktion.ebene) f.produktion.ebene = f.id;
        if (!f.produktion.artworks) f.produktion.artworks = Object.keys(alleArt).map(Number);
        if (!f.vorlagen) f.vorlagen = Object.keys(alleTpl);
      }
      if (f.erlaubt && f.erlaubt.charAt(0) === '@') f.erlaubt_regex = (DATEN.zeichen || {})[f.erlaubt.slice(1)] || null;
      else f.erlaubt_regex = f.erlaubt || null;
      f.pflicht = !!f.pflicht; f.beispiel_nicht_drucken = !!f.beispiel_nicht_drucken;
    });
    if (roh.schrift && roh.schrift.optionen) {
      roh.schrift.optionen = roh.schrift.optionen.map(function (id) {
        var o = (DATEN.schriften || {})[String(id)] || {}; var x = { id: id };
        for (var k in o) x[k] = o[k];
        return x;
      });
    }
    var g = roh.vorschau_geometrie || {};
    Object.keys(g).forEach(function (aid) {
      var v = g[aid].vorlagen || {};
      Object.keys(v).forEach(function (tid) {
        if (v[tid].wie && v[v[tid].wie]) { var basis = JSON.parse(JSON.stringify(v[v[tid].wie])); if (v[tid].hintergrund) basis.hintergrund = v[tid].hintergrund; v[tid] = basis; }
      });
    });
    (roh.varianten || []).forEach(function (vv) { vv.shopify_variante_id = String(vv.shopify_variante_id); });
    roh.verfuegbarkeit = matrix(roh.varianten || []);
    roh.shopify_id = String(pid);
    roh.__voll = true;
    return roh;
  }

  function matrix(vs) {
    var a = [], g = [], z = {};
    vs.forEach(function (v) {
      var aa = v.ausfuehrung || '-', gg = v.groesse_label || '-';
      if (v.layout) gg = gg === '-' ? v.layout : gg + ' · ' + v.layout;
      if (a.indexOf(aa) < 0) a.push(aa);
      if (g.indexOf(gg) < 0) g.push(gg);
      z[aa + '|' + gg] = { variante: v.shopify_variante_id, preis: v.preis, verfuegbar: !!v.verfuegbar };
    });
    return { ausfuehrungen: a, groessen: g, zellen: z };
  }

  function produkt(id, varianteId) {
    if (!DATEN || !DATEN.produkte) return null;
    var p = vollstaendig(String(id), DATEN.produkte[String(id)]);
    if (!p) return null;
    if (varianteId == null) return p;
    var v = (p.varianten || []).filter(function (x) { return String(x.shopify_variante_id) === String(varianteId); })[0] || null;
    var kopie = {}; for (var k in p) kopie[k] = p[k];
    kopie.variante = v;
    if (v && v.druckflaechen && p.system === 'teeinblue') {
      var arts = {}; v.druckflaechen.forEach(function (d) { (d.artwork_ids || []).forEach(function (a) { arts[a] = 1; }); });
      if (Object.keys(arts).length) kopie.felder = p.felder.filter(function (f) { return f.produktion.artworks.some(function (a) { return arts[a]; }); });
    }
    return kopie;
  }

  /* ================================================================ Prüfen (rein, ohne DOM) */
  function norm(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }
  function vergleich(s) { return norm(s).toLocaleLowerCase('de-DE'); }
  function zeichenZahl(s) { return Array.from(String(s || '')).length; }
  var DRUCKBAR_EXTRA = 'ıŒœ–—‘’‚“”„•…€';
  function nichtDruckbar(s) {
    var a = Array.from ? Array.from(String(s)) : String(s).split('');
    for (var i = 0; i < a.length; i++) {
      var c = a[i], k = c.codePointAt ? c.codePointAt(0) : c.charCodeAt(0);
      if (k === 10 || k === 13 || (k >= 32 && k <= 126) || (k >= 160 && k <= 255 && k !== 181 && k !== 173)) continue;
      if (DRUCKBAR_EXTRA.indexOf(c) > -1) continue;
      return c;
    }
    return null;
  }
  var ERSATZ = { 'ł': 'l', 'Ł': 'L', 'đ': 'd', 'Đ': 'D', 'ħ': 'h', 'Ħ': 'H', 'ŀ': 'l', 'Ŀ': 'L', 'ŧ': 't', 'Ŧ': 'T', 'ĸ': 'k', 'ŉ': 'n', 'ſ': 's', 'Ĳ': 'IJ', 'ĳ': 'ij', '„': '„' };
  function ersatzZeichen(c) {
    if (ERSATZ[c]) return ERSATZ[c];
    try { var b = c.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); if (b && b !== c && !nichtDruckbar(b)) return b; } catch (e) {}
    return '';
  }
  function text(schluessel, werte) {
    var t = (DATEN && DATEN.texte && DATEN.texte.meldungen && DATEN.texte.meldungen[schluessel]) || schluessel;
    return t.replace(/\{(\w+)\}/g, function (_, k) { return werte && werte[k] != null ? werte[k] : ''; });
  }
  function aktion(id) { return { id: id, text: (DATEN && DATEN.texte && DATEN.texte.aktionen && DATEN.texte.aktionen[id]) || id }; }
  function wer(f) { if (f.wer) return f.wer; var r = (DATEN && DATEN.texte && DATEN.texte.rollen && DATEN.texte.rollen[f.rolle]) || {}; return r.wer || ('„' + f.label + '“'); }
  function istBeispiel(wert, f) {
    var v = vergleich(wert); if (!v) return null;
    var liste = f.beispiele || [];
    for (var i = 0; i < liste.length; i++) if (vergleich(liste[i]) === v) return liste[i];
    return null;
  }
  function datumSchoen(v) {
    var m = String(v || '').match(/^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/); if (!m) return v || 'heute';
    var M = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    return (+m[3]) + '. ' + M[+m[2] - 1] + ' ' + m[1] + (m[4] ? ', ' + m[4] + ':' + m[5] + ' Uhr' : '');
  }

  function pruefe(id, eingabe) {
    var p = produkt(id, eingabe && eingabe.variante);
    var erg = { ok: true, fehler: [], hinweise: [], alle: [], produkt: id, konfig_version: DATEN && DATEN.konfig_version };
    if (!p) { erg.unbekannt = true; return erg; }
    eingabe = eingabe || {};
    var werte = eingabe.werte || {}, angefasst = eingabe.angefasst || {}, entschieden = eingabe.entschieden || {};
    var vorhanden = eingabe.vorhanden ? {} : null;
    if (vorhanden) eingabe.vorhanden.forEach(function (x) { vorhanden[x] = 1; });
    function melde(f, code, art, meldung, aktionen, extra) {
      var m = { feld: f.id, label: f.label, code: code, art: art, meldung: meldung, aktionen: aktionen || [] };
      if (extra) for (var k in extra) m[k] = extra[k];
      erg.alle.push(m);
      if (art === 'hinweis') erg.hinweise.push(m); else erg.fehler.push(m);
    }
    (p.felder || []).forEach(function (f) {
      if (vorhanden && !vorhanden[f.id]) return;
      if (f.automatisch || f.typ === 'abgeleitet') return;
      if (f.rolle === 'schrift' || f.rolle === 'farbe' || f.rolle === 'auswahl') return;
      var w = werte[f.id];
      if (f.typ === 'steine') {
        if (!w || !w.erster || !w.zweiter) melde(f, 'steine', 'fehler', 'Bitte wähle zuerst beide Steine.');
        return;
      }
      if (f.typ === 'photo') {
        w = w || {};
        if (!w.hochgeladen) { if (f.pflicht) melde(f, 'foto_fehlt', 'fehler', text('foto_fehlt')); return; }
        var soll = f.foto && f.foto.empfohlen_px;
        if (soll && w.breite && w.hoehe) {
          var gs = Math.max(soll[0], soll[1]), ks = Math.min(soll[0], soll[1]);
          var gi = Math.max(w.breite, w.hoehe), ki = Math.min(w.breite, w.hoehe);
          if (gi < gs || ki < ks) melde(f, 'foto_klein', 'hinweis', text('foto_klein', { breite: w.breite, hoehe: w.hoehe, soll_b: soll[0], soll_h: soll[1] }));
        }
        return;
      }
      if (f.typ === 'datei') {
        w = w || {};
        if (!w.datei) {
          if (entschieden[f.id] !== 'foto-spaeter') melde(f, 'foto_spaeter', 'entscheidung', text('foto_spaeter'), [aktion('foto_jetzt'), aktion('foto_spaeter')]);
          return;
        }
        var mk = f.foto && f.foto.min_kurze_seite;
        if (mk && w.breite && w.hoehe && Math.min(w.breite, w.hoehe) < mk) melde(f, 'foto_klein', 'hinweis', text('foto_klein', { breite: w.breite, hoehe: w.hoehe, soll_b: mk, soll_h: mk }));
        return;
      }
      if (f.typ === 'star-maps' || f.typ === 'maps') {
        w = w || {};
        if (!norm(w.name) || !w.gewaehlt) {
          melde(f, w.getippt && norm(w.name) ? 'ort_liste' : 'ort_waehlen', 'fehler', text(w.getippt && norm(w.name) ? 'ort_liste' : 'ort_waehlen'));
        }
        if (f.typ === 'star-maps') {
          var z = werte[f.id + ':zeit'];
          if (z && !z.geaendert && entschieden[f.id + ':zeit'] !== 'datum') {
            melde(f, 'datum_bestaetigen', 'entscheidung', text('datum_bestaetigen', { datum: datumSchoen(z.wert) }), [aktion('datum_waehlen'), aktion('datum_ok')], { teil: 'zeit', entscheid_schluessel: f.id + ':zeit', entscheid_wert: 'datum' });
          }
        }
        return;
      }
      if (f.typ === 'moon-phase' || f.typ === 'calendar' || f.typ === 'scrabble-crossword' || f.typ === 'clipart-category' || f.typ === 'group-clipart-categories' || f.typ === 'color') return;
      /* Textfelder (teeinblue text/paragraph, Schmuck-Properties) */
      if (w == null) w = '';
      if (typeof w !== 'string') w = String(w);
      var n = norm(w);
      if (!n) {
        if (f.pflicht) {
          if (f.rolle === 'initiale' && f.reihenfolge) melde(f, 'leer', 'fehler', text('initiale_leer', { nr: f.reihenfolge === 1 ? 'erste' : 'zweite' }));
          else melde(f, 'leer', 'fehler', text('leer', { wer: wer(f) }));
        } else if (p.system === 'teeinblue' && f.beispiel && entschieden[f.id] !== 'leer') {
          melde(f, 'leer_optional', 'entscheidung', text('leer_optional', { beispiel: f.beispiel }), [aktion('leer_lassen'), aktion('text_eintragen')], { entscheid_wert: 'leer' });
        }
        return;
      }
      var bsp = f.beispiel_nicht_drucken ? istBeispiel(n, f) : null;
      if (bsp && entschieden[f.id] !== 'beispiel') {
        if (!(f.rolle === 'initiale' && angefasst[f.id])) {
          melde(f, 'beispiel', 'fehler', text('beispiel', { wer: wer(f), beispiel: bsp }),
            angefasst[f.id] ? [{ id: 'beispiel_ok', text: 'Ja, genau so' }, aktion('text_eintragen')] : [], { entscheid_wert: 'beispiel' });
          return;
        }
      }
      // Druckschriften (teeinblue) können nur Latin-1 + wenige Satzzeichen (fontTools-cmap aller 27 Schriften,
      // 02.10.2026) – fehlende Zeichen würden leer oder in Ersatzschrift gedruckt. Nie still ersetzen, sondern melden.
      if (p.system === 'teeinblue') {
        var falsch = nichtDruckbar(w);
        if (falsch) {
          var ers = ersatzZeichen(falsch);
          melde(f, 'zeichen', 'fehler', 'Das Zeichen „' + falsch + '“ können wir leider nicht drucken' + (ers ? ' – bitte „' + ers + '“ verwenden.' : ' – bitte weglassen.'));
          return;
        }
      }
      var anz = zeichenZahl(w);
      if (f.max_zeichen && anz > f.max_zeichen) { melde(f, 'zu_lang', 'fehler', text('zu_lang', { max: f.max_zeichen, anzahl: anz })); return; }
      if (f.min_zeichen && zeichenZahl(n) < f.min_zeichen) { melde(f, 'zu_kurz', 'fehler', text('zu_kurz', { min: f.min_zeichen })); return; }
      if (f.max_zeilen && String(w).split('\n').length > f.max_zeilen) { melde(f, 'zeilen', 'fehler', text('zeilen', { max: f.max_zeilen })); return; }
      var rx = regex(f.erlaubt);
      if (rx) {
        if (f.rolle === 'initiale' && !f.initialen_anzahl) {
          if (!rx.test(n)) { melde(f, 'zeichen', 'fehler', text('initiale_zeichen')); return; }
        } else if (f.rolle === 'initiale' && f.initialen_anzahl) {
          var buchst = Array.from(n.replace(/[\s&+.,·-]/g, ''));
          if (buchst.length !== f.initialen_anzahl || buchst.some(function (c) { return !rx.test(c); })) {
            melde(f, 'zeichen', 'fehler', 'Bitte genau ' + f.initialen_anzahl + ' Buchstaben (A–Z, Ä, Ö, Ü).'); return;
          }
        } else if (!rx.test(w)) {
          var falsch = Array.from(w).filter(function (c) { return !rx.test(c); }).filter(function (c, i, a) { return a.indexOf(c) === i; }).join(' ');
          melde(f, 'zeichen', 'fehler', text('zeichen', { zeichen: falsch })); return;
        }
      }
      if (f.namen && f.namen.trenner === ',') {
        var teile = String(w).split(',');
        var leer = teile.slice(0, -1).some(function (t) { return !norm(t); }) || (teile.length > 1 && !norm(teile[teile.length - 1]) && teile.length > 2);
        var zahl = teile.filter(function (t) { return norm(t); }).length;
        if (f.namen.max_anzahl && zahl > f.namen.max_anzahl) { melde(f, 'namen_anzahl', 'fehler', text('namen_anzahl', { max: f.namen.max_anzahl, anzahl: zahl })); return; }
        if (leer) { melde(f, 'namen_trenner', 'fehler', text('namen_trenner')); return; }
      }
    });
    erg.ok = erg.fehler.length === 0;
    return erg;
  }

  function versionsWert() { return K.version + '/' + (DATEN ? DATEN.konfig_version : '?'); }

  function warenkorb(id, eingabe) {
    var p = produkt(id, eingabe && eingabe.variante), props = { _lr_konfig_version: versionsWert() };
    if (!p) return { properties: props, unbekannt: true };
    var werte = (eingabe && eingabe.werte) || {};
    (p.felder || []).forEach(function (f) {
      var pr = f.produktion || {};
      if (pr.system !== 'warenkorb-property' || !pr.property) return;
      if (f.typ === 'abgeleitet') {
        var teile = (f.abgeleitet_aus || []).map(function (q) { return norm(werte[q]).toLocaleUpperCase('de-DE'); });
        if (teile.every(Boolean)) props[pr.property] = teile.join(f.trenner || ' & ');
        return;
      }
      if (f.typ === 'datei' || f.typ === 'steine') return;
      var v = werte[f.id];
      if (v == null || !norm(v)) return;
      props[pr.property] = f.schreibweise === 'uppercase' ? String(v).toLocaleUpperCase('de-DE') : String(v);
    });
    return { properties: props };
  }

  /* Umstieg: Warenkorbzeile / Bestellposition lesen. Ohne _lr_konfig_version = Version 0 (vor der Konfiguration). */
  function zeileLesen(zeile) {
    var props = (zeile && (zeile.properties || zeile.customAttributes)) || {};
    if (Array.isArray(props)) { var o = {}; props.forEach(function (a) { o[a.key || a.name] = a.value; }); props = o; }
    var roh = props._lr_konfig_version;
    if (!roh) return { version: 0, status: 'manuell pruefen', grund: 'Zeile ohne _lr_konfig_version (vor der zentralen Konfiguration angelegt) – nach heutigem teeinblue-Stand lesen, nie verwerfen', properties: props };
    var m = String(roh).match(/^(\d+)\/(.+)$/);
    if (!m || +m[1] !== K.version) return { version: m ? +m[1] : roh, status: 'manuell pruefen', grund: 'unbekannte Schema-Version ' + roh, properties: props };
    return { version: +m[1], konfig_version: m[2], status: props._lr_pruefung && props._lr_pruefung !== 'ok' ? 'manuell pruefen' : 'ok', pruefung: props._lr_pruefung || null, properties: props };
  }

  /* sessionStorage lr7-mitnehmen (Schlüssel = Feldüberschrift) auf Feld-IDs übersetzen */
  function mitnehmenLesen(id) {
    var p = produkt(id); if (!p) return null;
    var d = null; try { d = JSON.parse(sessionStorage.getItem('lr7-mitnehmen') || 'null'); } catch (e) {}
    if (!d || !d.texte) return null;
    var out = {};
    p.felder.forEach(function (f) { var k = String(f.label || '').toLowerCase(); if (d.texte[k] != null) out[f.id] = d.texte[k]; });
    return { werte: out, ort: d.ort || null, motivIndex: d.motivIndex };
  }

  function nichtVorbelegen(pid, feldId) {
    if (!AKTIV || !DATEN) return false;
    var p = produkt(pid); if (!p) return false;
    var f = p.felder.filter(function (x) { return x.id === feldId; })[0];
    return !!(f && f.beispiel_nicht_drucken);
  }

  var K = {
    __lrk: true, version: 1, konfig_version: null, aktiv: AKTIV, geladen: false,
    produkt: produkt, pruefe: pruefe, warenkorb: warenkorb, zeileLesen: zeileLesen, mitnehmenLesen: mitnehmenLesen,
    nichtVorbelegen: nichtVorbelegen, laden: laden,
    /* Für Gestalter, die pruefe() selbst aufrufen und dann programmatisch .tee-btn--atc klicken:
       lässt diesen einen (untrusted) Klick max. 5 s ohne zweite Prüfung durch. Die Warenkorb-Kennungen
       (_lr_konfig_version, _lr_pruefung) hängt der fetch-Wrapper trotzdem an. */
    freigeben: function (ms) { FREIGABE_BIS = Date.now() + Math.min(ms || 2500, 5000); }
  };
  Object.defineProperty(K, 'bereit', { get: laden, enumerable: true });
  W.LoreliaKonfig = K;
  if (!AKTIV) return;          /* ohne Testschalter: nur Daten-API, keine Prüfschicht */
  laden().catch(function () {});

  /* ================================================================ Seite: gemeinsame Teile */
  function produktIdSeite() {
    try { if (W.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) return String(ShopifyAnalytics.meta.product.id); } catch (e) {}
    try { if (W.meta && W.meta.product) return String(W.meta.product.id); } catch (e) {}
    try { if (W.teeinblueCampaign && teeinblueCampaign.productId) return String(teeinblueCampaign.productId); } catch (e) {}
    var el = D.querySelector('[data-product-id]'); return el ? String(el.getAttribute('data-product-id')) : null;
  }
  var STIL = null, MARK = null, BLASE = null, BLASE_ZIEL = null, RAF = 0;
  function stil() {
    if (STIL) return;
    STIL = D.createElement('style'); STIL.id = 'lrk-stil';
    STIL.textContent =
      '.lrk-blase{position:fixed;z-index:2147483000;max-width:min(360px,calc(100vw - 24px));box-sizing:border-box;background:#2A2118;color:#fff;' +
      'font:500 14px/1.4 system-ui,-apple-system,sans-serif;border-radius:12px;padding:12px 38px 12px 14px;box-shadow:0 12px 30px -10px rgba(0,0,0,.45)}' +
      '.lrk-blase[data-art=hinweis]{background:#fff;color:#2A2118;box-shadow:0 0 0 1px #d9d2c7,0 12px 30px -12px rgba(0,0,0,.35)}' +
      '.lrk-blase:before{content:"";position:absolute;left:var(--lrk-pfeil,24px);width:12px;height:12px;background:inherit;transform:rotate(45deg)}' +
      '.lrk-blase[data-seite=unten]:before{top:-6px}.lrk-blase[data-seite=oben]:before{bottom:-6px}.lrk-blase[data-seite=frei]:before{display:none}' +
      '.lrk-blase p{margin:0}.lrk-blase small{display:block;margin-top:6px;opacity:.75;font-size:12.5px}' +
      '.lrk-blase .lrk-knoepfe{display:flex;gap:8px;flex-wrap:wrap;margin-top:10px}' +
      '.lrk-blase .lrk-knoepfe button{all:unset;cursor:pointer;box-sizing:border-box;min-height:36px;padding:8px 12px;border-radius:999px;background:#fff;color:#2A2118;font-weight:600;font-size:13.5px}' +
      '.lrk-blase[data-art=hinweis] .lrk-knoepfe button{background:#2A2118;color:#fff}' +
      '.lrk-blase .lrk-knoepfe button+button{background:transparent;color:inherit;box-shadow:inset 0 0 0 1px currentColor}' +
      '.lrk-blase .lrk-zu{all:unset;cursor:pointer;position:absolute;right:6px;top:6px;width:30px;height:30px;text-align:center;line-height:30px;font-size:18px;opacity:.8}' +
      '.lrk-ini{display:flex;align-items:center;gap:10px;margin-top:6px}' +
      '.lrk-ini label{display:flex;flex-direction:column;gap:4px;font-size:12.5px;color:inherit;opacity:.9}' +
      '.lrk-ini input{width:64px;height:56px;box-sizing:border-box;text-align:center;font-size:26px;text-transform:uppercase;border:1px solid #cfc6b8;border-radius:10px;background:#fff;color:#2A2118}' +
      '.lrk-ini input:focus{outline:2px solid #2A2118;outline-offset:1px}.lrk-ini b{font-size:22px;padding-top:18px}' +
      '.lrk-verborgen{position:absolute!important;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important;overflow:hidden!important}' +
      '.sch-eingabe--initiale{text-transform:uppercase}' +
      '.lrk-foto{margin-top:10px;display:flex;flex-direction:column;gap:6px}' +
      '.lrk-foto label.lrk-foto-knopf{display:inline-flex;align-items:center;gap:8px;cursor:pointer;min-height:44px;padding:0 14px;border:1px dashed #b9ad9b;border-radius:10px;font-weight:600}' +
      '.lrk-foto input[type=file]{position:absolute;width:1px;height:1px;opacity:0}' +
      '.lrk-foto .lrk-foto-info{font-size:13px;opacity:.85}.lrk-foto img{max-width:96px;max-height:96px;border-radius:8px;object-fit:cover}' +
      '@media (prefers-reduced-motion:no-preference){.lrk-blase{animation:lrk-rein .18s ease-out}@keyframes lrk-rein{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}}';
    D.head.appendChild(STIL);
    MARK = D.createElement('style'); MARK.id = 'lrk-mark'; D.head.appendChild(MARK);
  }
  function markiere(selektor) {
    stil();
    MARK.textContent = selektor ? selektor + '{outline:2px solid #B3261E!important;outline-offset:4px!important;border-radius:8px}' : '';
  }
  function sichtbarRect(el) { var r = el && el.getBoundingClientRect(); return r && (r.width || r.height) ? r : null; }
  function platziere() {
    RAF = 0;
    if (!BLASE || !BLASE_ZIEL) return;
    var r = sichtbarRect(BLASE_ZIEL), vw = W.innerWidth, vh = W.innerHeight;
    /* klebende Knopfleiste (Gestalter 8 / Schmuck) nicht verdecken, außer die Meldung gehört zum Knopf selbst */
    var leiste = D.querySelector('[data-lr-weiter]');
    var lr = leiste && !leiste.contains(BLASE_ZIEL) && BLASE_ZIEL !== leiste ? sichtbarRect(leiste) : null;
    if (lr && lr.top > vh * 0.6 && lr.top < vh) vh = lr.top - 4;
    var bw = BLASE.offsetWidth, bh = BLASE.offsetHeight;
    if (!r) { BLASE.style.left = Math.max(12, (vw - bw) / 2) + 'px'; BLASE.style.top = '12px'; BLASE.setAttribute('data-seite', 'frei'); return; }
    var left = Math.min(Math.max(12, r.left), Math.max(12, vw - bw - 12));
    var unten = r.bottom + 10, oben = r.top - bh - 10, seite = 'unten', top = unten;
    /* Im Gestalter (Handy) liegt das Produkt oben: Hinweise nie darüber legen, höchstens über das Formularblatt (05.10.2026) */
    var blatt = D.body.classList.contains('lr-gestalten') && BLASE.getAttribute('data-art') === 'hinweis' ? sichtbarRect(D.querySelector('.product-details')) : null;
    var minTop = blatt && blatt.top > 40 && blatt.top < vh * 0.8 ? blatt.top + 8 : 8;
    if (unten + bh > vh - 8 && oben > minTop) { top = oben; seite = 'oben'; }
    top = Math.min(Math.max(minTop, top), Math.max(minTop, vh - bh - 8));
    if (top !== unten && top !== oben) seite = 'frei';
    BLASE.style.left = left + 'px'; BLASE.style.top = top + 'px'; BLASE.setAttribute('data-seite', seite);
    BLASE.style.setProperty('--lrk-pfeil', Math.min(Math.max(14, r.left + Math.min(r.width, 60) / 2 - left), bw - 26) + 'px');
  }
  function planePlatz() { if (BLASE && !RAF) RAF = requestAnimationFrame(platziere); }
  /* Jeder Tipp außerhalb der Meldung schließt sie (die nächste Prüfung zeigt ggf. die nächste) */
  D.addEventListener('pointerdown', function (e) { if (BLASE && !(e.target && e.target.closest && e.target.closest('.lrk-blase'))) blaseZu(); }, { capture: true, passive: true });
  W.addEventListener('scroll', planePlatz, { capture: true, passive: true });
  W.addEventListener('resize', planePlatz, { passive: true });

  function blaseZu() {
    if (BLASE && BLASE.parentNode) BLASE.parentNode.removeChild(BLASE);
    BLASE = null; BLASE_ZIEL = null; markiere(null);
  }
  /* m = Meldung aus pruefe(); ziel = Element am Feld; markSel = CSS-Selektor fürs Feld; weitere = Anzahl weiterer Meldungen */
  function zeigeBlase(m, ziel, markSel, weitere, beiAktion) {
    stil(); blaseZu();
    var b = D.createElement('div'); b.className = 'lrk-blase'; b.setAttribute('role', 'alert'); b.setAttribute('aria-live', 'assertive');
    b.setAttribute('data-art', m.art); b.setAttribute('data-code', m.code); b.setAttribute('data-feld', m.feld);
    var p = D.createElement('p'); p.textContent = m.meldung; b.appendChild(p);
    if (weitere > 0) { var s = D.createElement('small'); s.textContent = weitere === 1 ? 'Danach noch 1 weitere Angabe prüfen.' : 'Danach noch ' + weitere + ' weitere Angaben prüfen.'; b.appendChild(s); }
    if (m.aktionen && m.aktionen.length) {
      var kn = D.createElement('div'); kn.className = 'lrk-knoepfe';
      m.aktionen.forEach(function (a) {
        var x = D.createElement('button'); x.type = 'button'; x.textContent = a.text; x.setAttribute('data-aktion', a.id);
        x.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (beiAktion) beiAktion(a.id, m); });
        kn.appendChild(x);
      });
      b.appendChild(kn);
    }
    var zu = D.createElement('button'); zu.type = 'button'; zu.className = 'lrk-zu'; zu.setAttribute('aria-label', 'Hinweis schließen'); zu.textContent = '×';
    zu.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); blaseZu(); });
    b.appendChild(zu);
    D.body.appendChild(b); BLASE = b; BLASE_ZIEL = ziel || null;
    markiere(m.art === 'hinweis' ? null : markSel);     /* Hinweise (z. B. Fotoauflösung) ohne rote Fehlermarkierung (05.10.2026) */
    if (ziel && ziel.scrollIntoView) { try { ziel.scrollIntoView({ block: 'center', behavior: RUHIG ? 'auto' : 'smooth' }); } catch (e) { ziel.scrollIntoView(); } }
    platziere(); setTimeout(platziere, RUHIG ? 0 : 420); setTimeout(platziere, 900);
    if (m.art === 'hinweis') setTimeout(function () { if (BLASE === b) blaseZu(); }, 12000);
  }
  function sel(s) { return String(s).replace(/(["\\])/g, '\\$1'); }

  /* Klick-Abfang: Fenster-Capture läuft vor allen Dokument-Handlern (lr-vorbelegen, Gestalter 8, teeinblue) */
  var FREIGABE_BIS = 0, LETZTER_AUSLOESER = null;

  laden().then(function () {
    var pid = produktIdSeite();
    var p = pid && produkt(pid);
    if (!p) return;                 /* Produkt nicht in der Konfiguration: nichts tun */
    if (p.system === 'teeinblue' && W.teeinblueCampaign) teeinblueSeite(pid, p);
    else if (p.system === 'theme-schmuck' && D.querySelector('[data-sch]')) schmuckSeite(pid, p);
    if (!K.seite) K.seite = { produkt: pid };
  }).catch(function () {});

  /* ================================================================ teeinblue (Poster, Fotoprodukte) */
  function teeinblueSeite(pid, p) {
    var angefasst = {}, entschieden = {}, ortStatus = {}, zeitGeaendert = {}, fotoInfo = {}, letzteCustomization = null;
    function camp() { return D.querySelector('.tee-campaign') || D; }
    function feldEl(f) { return camp().querySelector('.tee-field--' + f.id) || D.getElementById('tee-field--' + f.id); }
    function versteckt(el) {
      if (!el || !el.isConnected) return true;
      if (el.closest('[hidden]')) return true;
      return getComputedStyle(el).display === 'none' && !el.classList.contains('lr-weg');
    }
    function lidVon(el) { var f = el && el.closest && el.closest('.tee-field'); var m = f && String(f.className).match(/tee-field--(layer-\d+)/); return m ? m[1] : null; }

    D.addEventListener('input', function (e) {
      var t = e.target; if (!e.isTrusted || !t) return;
      if (t.name && /^layer-/.test(t.name)) { angefasst[t.name] = true; if (BLASE && BLASE.getAttribute('data-feld') === t.name) blaseZu(); }
      if (t.classList && t.classList.contains('tee-maps__input')) { var l = lidVon(t); if (l) ortStatus[l] = { getippt: true, gewaehlt: false }; }
    }, true);
    D.addEventListener('change', function (e) {
      var t = e.target; if (!t) return;
      if (e.isTrusted && t.type === 'datetime-local') { var l = lidVon(t); if (l) { zeitGeaendert[l] = true; if (BLASE && BLASE.getAttribute('data-feld') === l) blaseZu(); } }
      if (t.type === 'file' && t.files && t.files[0]) { var l2 = lidVon(t); if (l2) fotoMessen(l2, t.files[0]); }
    }, true);
    D.addEventListener('click', function (e) {
      var li = e.target && e.target.closest && e.target.closest('.tee-maps__searcher-item, .tee-maps__searcher-item-content');
      if (li) { var l = lidVon(li); if (l) { ortStatus[l] = { getippt: false, gewaehlt: true }; if (BLASE && BLASE.getAttribute('data-feld') === l) blaseZu(); } }
    }, true);

    function fotoMessen(lid, datei) {
      var fertig = function (b, h) {
        fotoInfo[lid] = { breite: b, hoehe: h, name: datei.name };
        var f = p.felder.filter(function (x) { return x.id === lid; })[0];
        if (!f) return;
        var r = pruefe(pid, { werte: (function () { var o = {}; o[lid] = { hochgeladen: true, breite: b, hoehe: h }; return o; })(), vorhanden: [lid] });
        var h1 = r.hinweise.filter(function (m) { return m.feld === lid; })[0];
        if (!h1) return;
        /* erst zeigen, wenn der teeinblue-Zuschneide-Dialog zu ist (sonst schließt der Tipp auf „Übernehmen“ den Hinweis) */
        var n = 0;
        (function warte() {
          var dlg = D.querySelector('.tee-dialog-image-cropper .vm--modal, .vm--container .vm--modal');
          if (dlg && sichtbarRect(dlg) && ++n < 90) return setTimeout(warte, 400);
          setTimeout(function () { var el = feldEl(f); zeigeBlase(h1, el && (el.querySelector('.tee-photo') || el), '.tee-field--' + lid, 0); }, 500);
        })();
      };
      if (W.createImageBitmap) {
        createImageBitmap(datei).then(function (bm) { fertig(bm.width, bm.height); if (bm.close) bm.close(); }).catch(function () { bild(); });
      } else bild();
      function bild() {
        var u = URL.createObjectURL(datei), im = new Image();
        im.onload = function () { fertig(im.naturalWidth, im.naturalHeight); URL.revokeObjectURL(u); };
        im.onerror = function () { URL.revokeObjectURL(u); };
        im.src = u;
      }
    }

    function eingabeLesen() {
      var werte = {}, vorhanden = [];
      p.felder.forEach(function (f) {
        var el = feldEl(f);
        if (!el || versteckt(el)) return;
        if (f.typ === 'text' || f.typ === 'paragraph') {
          var i = camp().querySelector('[name="' + sel(f.id) + '"]');
          if (!i) return;
          vorhanden.push(f.id); werte[f.id] = i.value || '';
        } else if (f.typ === 'photo') {
          vorhanden.push(f.id);
          var eigen = el.querySelector('.tee-photo-uploaded, img[src*="/uploads/"], img[src^="blob:"], img[src*="customers/"]');
          var leer = el.querySelector('.tee-photo-placeholder');
          var info = fotoInfo[f.id] || {};
          werte[f.id] = { hochgeladen: !!eigen || (!leer && !!info.breite), breite: info.breite, hoehe: info.hoehe };
        } else if (f.typ === 'star-maps') {
          var inp = el.querySelector('.tee-maps__input');
          if (!inp) return;
          vorhanden.push(f.id);
          var st = ortStatus[f.id] || {};
          var name = norm(inp.value);
          werte[f.id] = { name: name, gewaehlt: !!name && (st.gewaehlt || !st.getippt), getippt: !!st.getippt };
          var zi = el.querySelector('input[type="datetime-local"]');
          if (zi) {
            var jetzt = Date.now(), wert = zi.value, t = wert ? new Date(wert).getTime() : NaN;
            var geaendert = !!zeitGeaendert[f.id] || (!isNaN(t) && Math.abs(t - jetzt) > 45 * 60 * 1000);
            werte[f.id + ':zeit'] = { wert: wert, geaendert: geaendert };
          }
        } else if (f.typ === 'maps') {
          var nm = el.querySelector('.tee-field-maps-name');
          if (!nm) return;
          vorhanden.push(f.id);
          var gew = !nm.classList.contains('tee-field-maps-placeholder') && !!norm(nm.textContent);
          werte[f.id] = { name: gew ? norm(nm.textContent) : '', gewaehlt: gew };
        }
      });
      return { werte: werte, vorhanden: vorhanden, angefasst: angefasst, entschieden: entschieden, variante: varianteSeite() };
    }
    function varianteSeite() {
      var i = D.querySelector('form[action*="/cart/add"] [name="id"]');
      return i && i.value ? String(i.value) : null;
    }

    function zielFuer(m) {
      var f = p.felder.filter(function (x) { return x.id === m.feld; })[0];
      var el = f && feldEl(f);
      if (!el) return { el: null, sel: null };
      var inner = null;
      if (m.teil === 'zeit') inner = el.querySelector('input[type="datetime-local"]');
      else if (f.typ === 'star-maps') inner = el.querySelector('.tee-maps__input');
      else if (f.typ === 'maps') inner = el.querySelector('.tee-field-maps');
      else if (f.typ === 'photo') inner = el.querySelector('.tee-photo') || el;
      else inner = camp().querySelector('[name="' + sel(f.id) + '"]');
      return { el: inner || el, feld: el, sel: '#tee-field--' + f.id + ',.tee-field--' + f.id };
    }

    function gestalterZeigen(feld, danach) {
      /* Gestalter 8: Feld liegt evtl. in einem anderen Schritt -> dessen Reiter antippen (eigener Knopf des Gestalters, nicht teeinblue) */
      var tab = feld && feld.getAttribute('data-lr-tab');
      var offen = D.body.classList.contains('lr-gestalten');
      var warte = 0;
      if (!offen) { var auf = D.querySelector('[data-lr-auf]'); if (auf) { auf.click(); warte = 900; offen = true; } }
      setTimeout(function () {
        if (tab && offen && !D.body.classList.contains('lr-tab-' + tab)) { var r = D.querySelector('[data-lr-reiter="' + tab + '"]'); if (r) { r.click(); return setTimeout(danach, 480); } }
        danach();
      }, warte);
    }

    function aktionAusfuehren(id, mm) {
      if (id === 'leer_lassen') { entschieden[mm.feld] = 'leer'; blaseZu(); nochmal(); }
      else if (id === 'datum_ok') { entschieden[mm.entscheid_schluessel] = 'datum'; blaseZu(); nochmal(); }
      else if (id === 'beispiel_ok') { entschieden[mm.feld] = 'beispiel'; blaseZu(); nochmal(); }
      else if (id === 'text_eintragen' || id === 'datum_waehlen') {
        blaseZu();
        var z0 = zielFuer(mm);
        gestalterZeigen(z0.feld, function () {
          var zz = zielFuer(mm); markiere(zz.sel);
          if (zz.el && zz.el.scrollIntoView) zz.el.scrollIntoView({ block: 'center', behavior: RUHIG ? 'auto' : 'smooth' });
          if (zz.el && zz.el.focus) { try { zz.el.focus({ preventScroll: true }); } catch (x) { zz.el.focus(); } }
          setTimeout(function () { markiere(null); }, 4000);
        });
      }
    }
    function melden(erg) {
      var liste = erg.fehler.filter(function (m) { return m.art === 'fehler'; });
      if (!liste.length) liste = erg.fehler;
      var m = liste[0], z = zielFuer(m);
      if (m.art === 'entscheidung' && LETZTER_AUSLOESER && sichtbarRect(LETZTER_AUSLOESER)) {
        /* Rückfrage (leer lassen? Datum so?): am Warenkorb-Knopf fragen, ohne den Schritt zu wechseln; das Feld wird markiert */
        zeigeBlase(m, LETZTER_AUSLOESER, z.sel, erg.fehler.length - 1, aktionAusfuehren);
        return;
      }
      gestalterZeigen(z.feld, function () {
        var z2 = zielFuer(m);
        zeigeBlase(m, z2.el, z2.sel, erg.fehler.length - 1, aktionAusfuehren);
      });
    }
    function nochmal() {
      var b = LETZTER_AUSLOESER;
      if (!b || !b.isConnected) return;
      if (b.hasAttribute('data-lr-weiter') && !/^\s*In den Warenkorb/i.test(b.textContent || '')) return;
      setTimeout(function () { b.click(); }, 60);
    }

    /* Gestalter 8 prüft beim Schritt zu „Ansehen“/„Prüfen“ selbst leere Sternchen-Felder (Meldung im Kopf).
       Wir prüfen an denselben Stellen zuerst, damit die Meldung einheitlich AM Feld steht; Rückfragen erst am Warenkorb. */
    var SCHRITT_RX = /^\s*Weiter:\s*(Ansehen|Prüfen)/i;
    function istWarenkorbKnopf(t) {
      var b = t && t.closest && t.closest('[data-lr-weiter], .tee-btn--atc, .add-to-cart-button, button[name="add"]');
      if (!b) return null;
      if (b.hasAttribute('data-lr-weiter')) return /^\s*In den Warenkorb/i.test(b.textContent || '') || SCHRITT_RX.test(b.textContent || '') ? b : null;
      if (b.closest('.lrk-blase')) return null;
      return b;
    }
    W.addEventListener('click', function (e) {
      var b = istWarenkorbKnopf(e.target);
      if (!b) return;
      var nurSchritt = b.hasAttribute('data-lr-weiter') && SCHRITT_RX.test(b.textContent || '');
      /* Horizon-Warenkorbknopf (ohne teeinblue-Gestaltung) würde ein ungestaltetes, nicht druckbares Produkt anlegen */
      if (!b.hasAttribute('data-lr-weiter') && !b.matches('.tee-btn--atc') && !b.closest('.tee-campaign')) {
        e.preventDefault(); e.stopImmediatePropagation();
        var auf = D.querySelector('[data-lr-auf]');
        zeigeBlase({ feld: '', code: 'gestalter', art: 'fehler', meldung: 'Bitte gestalte dein Stück zuerst im Gestalter – nur so wird deine Gestaltung gedruckt.', aktionen: auf ? [{ id: 'auf', text: 'Jetzt gestalten' }] : [] },
          b, null, 0, function () { blaseZu(); if (auf) auf.click(); });
        return;
      }
      if (!e.isTrusted && b.matches('.tee-btn--atc') && Date.now() < FREIGABE_BIS) return;   /* Gestalter 8 ruft nach unserer Freigabe atc.click() */
      var erg;
      try {
        if (W.LoreliaVorbelegen && LoreliaVorbelegen.fuellen) LoreliaVorbelegen.fuellen();   /* erlaubte Vorbelegung zuerst (Titel u. ä.) */
        erg = pruefe(pid, eingabeLesen());
      } catch (x) { return; }      /* eigener Fehler: nie den Kauf blockieren */
      K.letztePruefung = erg;
      if (nurSchritt) {
        erg = { ok: !erg.fehler.some(function (m) { return m.art === 'fehler'; }), fehler: erg.fehler.filter(function (m) { return m.art === 'fehler'; }), hinweise: erg.hinweise, alle: erg.alle };
        if (erg.ok) { blaseZu(); return; }
      }
      if (erg.ok) { FREIGABE_BIS = Date.now() + 2500; blaseZu(); return; }
      e.preventDefault(); e.stopImmediatePropagation();
      LETZTER_AUSLOESER = b;
      melden(erg);
    }, true);

    /* Übergabe: teeinblue legt die Zeile per fetch('/cart/add.js') an. Wir hängen nur versteckte Kennungen an
       (_lr_konfig_version, _lr_pruefung) – Kundeneingaben und teeinblue-Properties bleiben unverändert. */
    var ofetch = W.fetch;
    if (ofetch && !ofetch.__lrk) {
      var neu = function (eingang, opt) {
        try {
          var url = String(eingang && eingang.url || eingang);
          var methode = (opt && opt.method || (eingang && eingang.method) || 'GET').toUpperCase();
          if (methode === 'POST' && /api\.teeinblue\.com\/api\/merchant\/shopify\/customization/.test(url) && opt && typeof opt.body === 'string') {
            try { letzteCustomization = JSON.parse(opt.body).data || null; } catch (x) {}
          }
          if (methode === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && opt && typeof opt.body === 'string' && /_customization_id/.test(opt.body)) {
            var body = JSON.parse(opt.body);
            var ziele = body.items ? body.items : [body];
            ziele.forEach(function (it) {
              if (!it || !it.properties || !it.properties._customization_id) return;
              it.properties._lr_konfig_version = versionsWert();
              it.properties._lr_pruefung = datenPruefung(letzteCustomization);
            });
            opt = Object.assign({}, opt, { body: JSON.stringify(body) });
          }
        } catch (x) {}
        return ofetch.call(this, eingang, opt);
      };
      neu.__lrk = true;
      W.fetch = neu;
    }
    /* Prüfung der tatsächlich an teeinblue übergebenen Gestaltung (was gedruckt wird) */
    function datenPruefung(daten) {
      if (!daten) return 'manuell prüfen: Gestaltungsdaten nicht mitgelesen';
      var probleme = [];
      p.felder.forEach(function (f) {
        var v = daten[f.id];
        /* nur Felder der tatsächlich gewählten Vorlage (daten["<artwork>"] = "template-…") */
        var inVorlage = f.produktion.artworks.some(function (a) { var t = daten[String(a)]; return t != null && (!f.vorlagen || f.vorlagen.indexOf(t) >= 0); });
        if (!inVorlage) return;
        if ((f.typ === 'text' || f.typ === 'paragraph') && f.beispiel_nicht_drucken && typeof v === 'string' && istBeispiel(v, f) && entschieden[f.id] !== 'beispiel') probleme.push('Beispiel in ' + f.label);
        if ((f.typ === 'text' || f.typ === 'paragraph') && f.pflicht && !norm(v)) probleme.push(f.label + ' leer');
        if (f.typ === 'photo' && f.pflicht && !v) probleme.push('Foto fehlt (' + f.label + ')');
        if ((f.typ === 'star-maps' || f.typ === 'maps') && (!v || !v.name)) probleme.push('Ort nicht gewählt (' + f.label + ')');
      });
      probleme = probleme.filter(function (x, i, a) { return a.indexOf(x) === i; });
      return probleme.length ? 'manuell prüfen: ' + probleme.join('; ') : 'ok';
    }

    K.seite = { produkt: pid, eingabe: eingabeLesen, pruefen: function () { return pruefe(pid, eingabeLesen()); }, entschieden: entschieden };
  }

  /* ================================================================ Schmuck (lr-sch-produkt.liquid + lr-sch.js) */
  function schmuckSeite(pid, p) {
    var root = D.querySelector('[data-sch]'), form = root && root.querySelector('[data-sch-form]');
    if (!form) return;
    stil();
    var entschieden = {}, angefasst = {}, fotoDatei = null, fotoMass = null;
    var nameIn = root.querySelector('[data-sch-name]');
    var fName = p.felder.filter(function (f) { return f.id === 'Name'; })[0];
    var ini = p.felder.filter(function (f) { return f.id === 'Initiale 1' || f.id === 'Initiale 2'; });
    var fFoto = p.felder.filter(function (f) { return f.typ === 'datei'; })[0];
    function versteckt(name, wert) {
      var i = form.querySelector('input[type=hidden][name="properties[' + name + ']"][data-lrk]');
      if (!i) { i = D.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + name + ']'; i.setAttribute('data-lrk', '1'); form.appendChild(i); }
      i.value = wert == null ? '' : wert;
      return i;
    }
    versteckt('_lr_konfig_version', versionsWert());

    /* Platzhalter aus der Konfiguration (VEDA, ALVA …) */
    if (nameIn && fName && fName.platzhalter && nameIn.placeholder !== fName.platzhalter) nameIn.placeholder = fName.platzhalter;
    if (nameIn) nameIn.addEventListener('input', function (e) { if (e.isTrusted) angefasst.Name = true; if (BLASE && BLASE.getAttribute('data-feld') === 'Name') blaseZu(); });

    /* Zwei Initialen: zwei Buchstabenfelder in fester Reihenfolge; das bisherige Feld bleibt (versteckt) die Fertigungsangabe "A & J" */
    var iniIn = [];
    if (ini.length === 2 && nameIn) {
      var box = nameIn.closest('[data-sch-perso]') || nameIn.parentNode;
      var wrap = D.createElement('div'); wrap.className = 'lrk-ini'; wrap.setAttribute('data-lrk-ini', '1');
      ini.sort(function (a, b) { return (a.reihenfolge || 0) - (b.reihenfolge || 0); }).forEach(function (f, k) {
        var lab = D.createElement('label'); lab.textContent = f.label;
        var i = D.createElement('input'); i.type = 'text'; i.maxLength = 1; i.autocomplete = 'off'; i.setAttribute('autocapitalize', 'characters');
        i.setAttribute('autocorrect', 'off'); i.spellcheck = false; i.setAttribute('enterkeyhint', k === 0 ? 'next' : 'done');
        i.setAttribute('aria-label', f.label); i.placeholder = f.platzhalter || ''; i.setAttribute('data-lrk-feld', f.id);
        i.addEventListener('input', function (e) {
          if (e.isTrusted) angefasst[f.id] = true;
          if (BLASE && BLASE.getAttribute('data-feld') === f.id) blaseZu();
          iniUebertragen();
          if (k === 0 && i.value && iniIn[1] && !iniIn[1].value) iniIn[1].focus();
        });
        lab.appendChild(i); wrap.appendChild(lab); iniIn.push(i);
        if (k === 0) { var und = D.createElement('b'); und.textContent = '&'; und.setAttribute('aria-hidden', 'true'); wrap.appendChild(und); }
      });
      nameIn.parentNode.insertBefore(wrap, nameIn);
      nameIn.classList.add('lrk-verborgen'); nameIn.setAttribute('tabindex', '-1'); nameIn.setAttribute('aria-hidden', 'true');
      var zahl = box.querySelector('[data-sch-zahl]'); if (zahl) zahl.textContent = 'je 1 Buchstabe';
    }
    function iniWerte() { var o = {}; iniIn.forEach(function (i) { o[i.getAttribute('data-lrk-feld')] = i.value; }); return o; }
    function iniUebertragen() {
      /* nur das eigene Theme-Formular (nicht teeinblue): sichtbarer Wert = gespeicherter Wert, in Großbuchstaben */
      var w = warenkorb(pid, { werte: iniWerte() }).properties;
      var v = w.Name || iniIn.map(function (i) { return i.value.toLocaleUpperCase('de-DE'); }).filter(Boolean).join(' & ');
      var proto = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
      proto.set.call(nameIn, v);
      nameIn.dispatchEvent(new Event('input', { bubbles: true }));     /* lr-sch.js zeichnet damit die Vorschau */
    }

    /* Foto-Upload statt "per E-Mail" (Datei wird mit dem Warenkorb an Shopify geschickt) */
    var fotoIn = null, fotoInfo = null, fotoText = root.querySelector('.sch-foto span');
    if (fFoto) {
      var fbox = D.createElement('div'); fbox.className = 'lrk-foto'; fbox.setAttribute('data-lrk-foto', '1');
      var fid = 'lrk-foto-' + pid;
      fbox.innerHTML = '<label class="lrk-foto-knopf" for="' + fid + '"><span>Foto auswählen</span></label>' +
        '<input type="file" id="' + fid + '" accept="' + (fFoto.foto && fFoto.foto.akzeptiert || 'image/*') + '">' +
        '<p class="lrk-foto-info" data-lrk-foto-info></p>';
      var anker = root.querySelector('.sch-foto') || (nameIn && nameIn.closest('[data-sch-perso]')) || form.querySelector('[data-sch-cta]');
      if (anker && anker.parentNode) anker.parentNode.insertBefore(fbox, anker.classList && anker.classList.contains('sch-foto') ? anker.nextSibling : anker);
      else form.appendChild(fbox);
      if (fotoText) fotoText.textContent = fFoto.hilfe;
      fotoIn = fbox.querySelector('input'); fotoInfo = fbox.querySelector('[data-lrk-foto-info]');
      fotoIn.addEventListener('change', function () {
        fotoDatei = fotoIn.files && fotoIn.files[0] || null; fotoMass = null;
        if (BLASE && BLASE.getAttribute('data-feld') === fFoto.id) blaseZu();
        if (!fotoDatei) { fotoInfo.textContent = ''; return; }
        var maxMb = fFoto.foto && fFoto.foto.max_mb;
        fotoInfo.textContent = fotoDatei.name + ' · ' + (fotoDatei.size / 1048576).toFixed(1) + ' MB';
        if (maxMb && fotoDatei.size > maxMb * 1048576) fotoInfo.textContent += ' – sehr groß, das Hochladen kann etwas dauern.';
        var u = URL.createObjectURL(fotoDatei), im = new Image();
        im.onload = function () {
          fotoMass = { breite: im.naturalWidth, hoehe: im.naturalHeight };
          var r = pruefe(pid, { werte: { Foto: { datei: true, breite: fotoMass.breite, hoehe: fotoMass.hoehe } }, vorhanden: [fFoto.id] });
          var h = r.hinweise[0];
          fotoInfo.textContent = fotoDatei.name + ' · ' + fotoMass.breite + ' × ' + fotoMass.hoehe + ' px';
          var alt = fbox.querySelector('img'); if (alt) alt.remove();
          var vs = D.createElement('img'); vs.alt = 'Dein Foto'; vs.src = u; fbox.insertBefore(vs, fotoInfo);
          if (h) zeigeBlase(h, fbox, '[data-lrk-foto]', 0);
        };
        im.onerror = function () { URL.revokeObjectURL(u); fotoInfo.textContent = fotoDatei.name + ' – Vorschau nicht möglich (z. B. HEIC), das Foto wird trotzdem mitgeschickt.'; };
        im.src = u;
      });
    }

    function eingabeLesen() {
      var werte = {}, vorhanden = [];
      p.felder.forEach(function (f) {
        if (f.typ === 'steine') { var a = form.querySelector('[data-prop1]'), b = form.querySelector('[data-prop2]'); if (a || b) { vorhanden.push(f.id); werte[f.id] = { erster: a && a.value, zweiter: b && b.value }; } }
        else if (f.id === 'Initiale 1' || f.id === 'Initiale 2') { if (iniIn.length) { vorhanden.push(f.id); werte[f.id] = iniWerte()[f.id] || ''; } }
        else if (f.id === 'Name' && f.typ !== 'abgeleitet') { if (nameIn) { vorhanden.push(f.id); werte.Name = nameIn.value; } }
        else if (f.typ === 'datei') { vorhanden.push(f.id); werte[f.id] = { datei: !!fotoDatei, breite: fotoMass && fotoMass.breite, hoehe: fotoMass && fotoMass.hoehe }; }
      });
      return { werte: werte, vorhanden: vorhanden, angefasst: angefasst, entschieden: entschieden };
    }
    function zielFuer(m) {
      if (m.feld === 'Initiale 1') return { el: iniIn[0], sel: '[data-lrk-feld="Initiale 1"]' };
      if (m.feld === 'Initiale 2') return { el: iniIn[1], sel: '[data-lrk-feld="Initiale 2"]' };
      if (m.feld === 'Name') return { el: nameIn, sel: '#sch-name' };
      if (fFoto && m.feld === fFoto.id) return { el: root.querySelector('[data-lrk-foto]'), sel: '[data-lrk-foto] .lrk-foto-knopf' };
      if (m.feld === 'Steine') return { el: root.querySelector('[data-lr-picker]'), sel: '[data-lr-picker]' };
      return { el: form, sel: null };
    }
    var ausloeser = null;
    function melden(erg) {
      var liste = erg.fehler.filter(function (m) { return m.art === 'fehler'; });
      if (!liste.length) liste = erg.fehler;
      var m = liste[0], z = zielFuer(m);
      zeigeBlase(m, z.el, z.sel, erg.fehler.length - 1, function (id, mm) {
        if (id === 'foto_spaeter') { entschieden[mm.feld] = 'foto-spaeter'; blaseZu(); if (ausloeser) setTimeout(function () { ausloeser.click(); }, 60); }
        else if (id === 'foto_jetzt') { blaseZu(); if (fotoIn) fotoIn.click(); }
        else if (id === 'beispiel_ok') { entschieden[mm.feld] = 'beispiel'; blaseZu(); if (ausloeser) setTimeout(function () { ausloeser.click(); }, 60); }
        else if (id === 'text_eintragen') { blaseZu(); var zz = zielFuer(mm); if (zz.el) zz.el.focus(); }
      });
      if (z.el && z.el.focus && m.art === 'fehler' && z.el.tagName === 'INPUT') setTimeout(function () { try { z.el.focus({ preventScroll: true }); } catch (x) {} }, RUHIG ? 0 : 450);
    }
    function vorbereiten() {
      /* Großbuchstaben für Initialen (sichtbar per CSS schon beim Tippen) und abgeleitete Properties */
      if (iniIn.length) {
        var w = warenkorb(pid, { werte: iniWerte() }).properties;
        versteckt('Initiale 1', w['Initiale 1'] || ''); versteckt('Initiale 2', w['Initiale 2'] || '');
        iniUebertragen();
      } else if (nameIn && fName && fName.schreibweise === 'uppercase' && nameIn.value !== nameIn.value.toLocaleUpperCase('de-DE')) {
        Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(nameIn, nameIn.value.toLocaleUpperCase('de-DE'));
      }
      versteckt('_lr_konfig_version', versionsWert());
    }
    function abfangen(e, knopf) {
      var erg;
      try { erg = pruefe(pid, eingabeLesen()); } catch (x) { return; }
      K.letztePruefung = erg;
      if (!erg.ok) { e.preventDefault(); e.stopImmediatePropagation(); ausloeser = knopf || ausloeser; melden(erg); return; }
      blaseZu();
      vorbereiten();
      if (fotoDatei) { e.preventDefault(); e.stopImmediatePropagation(); mitFotoSenden(); }
    }
    W.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-sch-atc]');
      if (!b || b.disabled || !root.contains(b)) return;
      abfangen(e, b);
    }, true);
    W.addEventListener('submit', function (e) { if (e.target === form) abfangen(e, null); }, true);

    /* Warenkorb mit Datei: gleiche Properties wie lr-sch.js, aber als FormData (Shopify speichert Datei-Properties) */
    function mitFotoSenden() {
      var knoepfe = [].slice.call(root.querySelectorAll('[data-sch-atc]')), meld = root.querySelector('[data-sch-meldung]');
      var fd = new FormData(), idIn = form.querySelector('[data-sch-id]');
      fd.append('id', idIn ? idIn.value : '');
      fd.append('quantity', '1');
      [].slice.call(form.querySelectorAll('[name^="properties["]')).forEach(function (i) {
        if (i.disabled || !i.value || i.type === 'file') return;
        if (fFoto && i.name === 'properties[' + fFoto.produktion.property + ']') return;   /* "per E-Mail"-Text entfällt, die Datei ersetzt ihn */
        fd.append(i.name, i.value);
      });
      fd.append('properties[' + (fFoto.produktion.property || 'Foto') + ']', fotoDatei, fotoDatei.name);
      knoepfe.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      if (meld) meld.textContent = 'Foto wird hochgeladen …';
      var boxId = root.getAttribute('data-box-id'), gSch = root.querySelector('[data-sch-geschenk]');
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && res.j.description) || 'Das hat nicht geklappt.');
          if (boxId && gSch && gSch.getAttribute('aria-checked') === 'true') {
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(boxId, 10), quantity: 1 }] }) }).then(function () { return res; });
          }
          return res;
        })
        .then(function () {
          knoepfe.forEach(function (b) { b.removeAttribute('aria-busy'); b.classList.add('is-drin'); var t = b.querySelector('[data-sch-atc-text]'); if (t) t.textContent = '✓ Im Warenkorb'; else b.textContent = '✓ Im Warenkorb'; });
          if (meld) meld.textContent = (root.getAttribute('data-title') || 'Dein Stück') + ' liegt im Warenkorb.';
          D.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          if (!K.keinWeiterleiten) setTimeout(function () { location.href = '/cart'; }, 1100);
        })
        .catch(function (err) {
          knoepfe.forEach(function (b) { b.removeAttribute('aria-busy'); });
          if (meld) meld.textContent = (err && err.message) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
        });
    }
    K.seite = { produkt: pid, eingabe: eingabeLesen, pruefen: function () { return pruefe(pid, eingabeLesen()); }, entschieden: entschieden };
  }
})();
